'use client';

import { useCallback } from 'react';
import { DRIFT_CLIENT_OPTS } from 'src/stores/DriftStore/constants';
import { dlog } from 'src/dev';
import useDriftClient from 'src/hooks/useDriftClient';

/**
 * Hook for managing transaction preflight checks configuration.
 */
export const useTransactionPreflights = () => {
	const driftClient = useDriftClient();

	const handleUpdateTransactionPreflights = useCallback(
		(skipPreFlights: boolean) => {
			// This ensures any future drift clients get use the correct preflight settings
			DRIFT_CLIENT_OPTS.skipPreflight = skipPreFlights;

			dlog(
				'feature_flags',
				'updating_skipPreflight_on_driftClient',
				skipPreFlights
			);

			if (!driftClient) {
				// If we don't currently have a drift client then it should be sufficient to return here after we've updated the DRIFT_CLIENT_OPTS
				return;
			}

			if (!driftClient.opts) {
				driftClient.opts = {
					skipPreflight: skipPreFlights,
				};
			} else {
				driftClient.opts = {
					...driftClient.opts,
					skipPreflight: skipPreFlights,
				};
			}
		},
		[driftClient]
	);

	return { handleUpdateTransactionPreflights };
};
